import React, { useMemo, useContext } from 'react';
import { MultiScreenServer } from '../communication/MultiScreenServer';
import { useMultiScreenController } from './useMultiScreenController';

const MultiScreenServerContext = React.createContext<MultiScreenServer | undefined>(undefined);

export function useMultiScreenServer() {
    return useContext(MultiScreenServerContext);
}

export function withMultiScreenServer(node: JSX.Element) {
    function WithMultiScreenServer(props: React.PropsWithChildren<{}>) {
        const controller = useMultiScreenController();

        const server = useMemo(() => controller ? new MultiScreenServer(controller) : undefined, [controller]);

        return (
            <MultiScreenServerContext.Provider value={server}>
                {props.children}
            </MultiScreenServerContext.Provider>
        );
    }

    return <WithMultiScreenServer>{node}</WithMultiScreenServer>;
}
